import React from 'react';
import ActiveUsers from './ActiveUsers';
import TenantCount from './TenantCount';

function Dashboard() {
  return <>
    <ActiveUsers />
    <TenantCount />
  </>;
}

export default Dashboard;
